export const Errors = {
	DISCONNECTED: 'DISCONNECTED'
};
